import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function PersonalInfoUse({ onClose }: ModalProps) {
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>개인정보 수집 및 활용 동의</S.ModalTitle>
        <S.ModalContent>
          <S.NoticeTitle> 가. 수집 및 이용 목적</S.NoticeTitle>
          <S.Notice>
            <li>
              페스티맵에서 실시하는 &quot2025 목포해상W쇼 데크 관람석 입장권
              예매&quot 에 필요한 사항(예매 중복 참여 방지 등)에 대하여 입장권
              예매 서비스 제공을 위하여 필요한 최소한의 범위 내에서 개인정보를
              수집하고 있습니다.
            </li>
          </S.Notice>
          <S.NoticeTitle>나. 수집 및 이용 항목</S.NoticeTitle>
          <S.Notice>
            <li>
              필수항목 : 성명, 전화번호, 참여인원 개인정보 수집 동의 항목 기입
              시 페스티맵이 위와 같이 개인정보 필수항목을 수집ㆍ이용하는 것에
              동의하는 것으로 간주합니다.
            </li>
          </S.Notice>
          <S.NoticeTitle>다. 개인정보의 보유 및 이용 기간</S.NoticeTitle>
          <S.Notice>
            <li>
              참여자의 개인정보 수집ㆍ이용에 관한 동의일로부터 2025 목포해상W쇼
              종료 시까지 위 이용목적을 위하여 보유 및 이용하게 됩니다. 단, 축제
              종료 후에는 민원처리, 분쟁해결 및 법령상 의무이행 등을 위하여
              1년간 보유하게 됩니다.
            </li>
          </S.Notice>
          <S.NoticeTitle>
            라. 동의를 거부할 권리 및 동의를 거부할 경우의 불이익
          </S.NoticeTitle>
          <S.Notice>
            <li>
              위 개인정보 중 필수정보의 수집ㆍ이용에 관한 동의는 &quot2025
              목포해상W쇼 데크 관람석 입장권 예매&quot 진행을 위해 필수적이므로,
              위 사항에 동의하셔야만 입장권 예매 및 입장권 수령이 가능합니다.
            </li>
          </S.Notice>
        </S.ModalContent>
        <S.ConfirmButton type="button" onClick={onClose}>
          확인
        </S.ConfirmButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
